// Selectable countries for the visible region/country picker (P2b-2).
//
// This drives per-country content variants via the `X-Request-Country` header
// (see services/requestCountry.js). It is deliberately a small brand-level list:
// GCC (this brand) targets Australia / New Zealand / Canada / Ireland — all
// English, but with per-country content variants (en-AU/en-NZ/en-CA/en-IE).
//
// On a non-GCC brand this list should be empty, so <CountrySwitcherDropdown/>
// renders nothing and the whole feature stays inert. Flags are served from the
// app's own /flags/<code>.svg assets.
export const SELECTABLE_COUNTRIES = [
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "CA", name: "Canada" },
  { code: "IE", name: "Ireland" },
];

/** Flag asset path for an ISO2 country code, served from the app docroot. */
export function countryFlagPath(code) {
  const c = (code || "").toString().trim().toLowerCase();
  return c ? `/flags/${c}.svg` : "";
}
